import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo/app-logo.svg";
import { useNavigate } from "react-router-dom";
import RoutingPaths from "../../utils/RoutingPaths";
import orgLogo from "../../assets/images/org_logo.png";
import ChangePasswordModal from "../../modals/dashboard/ChangePasswordModal";
import {
  getConsultant,
  updateConsultant,
} from "../../services/api_services/ConsultantServices";
import { updateAdminUserDetails } from "../../services/api_services/AuthServices";
import { getLoggedInUserDetails } from "../../services/api_services/DashboardServices";
import { useLocation } from "react-router-dom";

function AppBar(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const hideBranchRoutes = [
    RoutingPaths.REPORTS,
    RoutingPaths.ACCOUNT_SETTINGS,
    RoutingPaths.MESSAGES,
    RoutingPaths.INVENTORIES,
    RoutingPaths.APPOINTMENT_DETAILS,
    RoutingPaths.HOSPITALIZATION,
  ];

  const isContactsBasePage = location.pathname === RoutingPaths.CONTACTS;

  const isContactDetailsPage = location.pathname.startsWith(
    RoutingPaths.CONTACTS + "/",
  );

  const isConsultantsBasePage = location.pathname === RoutingPaths.CONSULTANTS;

  const isConsultantDetailsPage = location.pathname.startsWith(
    RoutingPaths.CONSULTANTS + "/",
  );

  const [showBranchForTab, setShowBranchForTab] = useState(
    sessionStorage.getItem("SHOW_BRANCH_FOR_TAB") === "true",
  );

  const shouldHideBranch =
    hideBranchRoutes.some((route) => location.pathname.startsWith(route)) ||
    isContactsBasePage ||
    (isContactDetailsPage && !showBranchForTab) ||
    isConsultantsBasePage ||
    (isConsultantDetailsPage && !showBranchForTab);

  useEffect(() => {
    const handleTabChange = () => {
      const value = sessionStorage.getItem("SHOW_BRANCH_FOR_TAB") === "true";
      setShowBranchForTab(value);
    };

    window.addEventListener("tabChanged", handleTabChange);

    return () => {
      window.removeEventListener("tabChanged", handleTabChange);
    };
  }, []);

  const client = JSON.parse(sessionStorage.getItem("ClientDetails"));
  const consultant = JSON.parse(sessionStorage.getItem("ConsultantDetails"));

  const allowedBranches = props?.profileData?.allowedBranches || [];
  const restrictBranchAccess = props?.profileData?.restrictBranchAccess;

  const filteredAddresses = !restrictBranchAccess
    ? props.address
    : props.address?.filter((addr) => {
        const id = addr.id ?? addr.addressId;
        return allowedBranches.includes(id);
      });

  useEffect(() => {
    if (restrictBranchAccess && filteredAddresses?.length === 1) {
      const singleBranchId =
        filteredAddresses[0].id ?? filteredAddresses[0].addressId;

      setSelectedBranch(singleBranchId);
      sessionStorage.setItem("SelectedBranch", JSON.stringify(singleBranchId));

      window.dispatchEvent(new Event("branchChanged"));
    }
  }, [restrictBranchAccess, filteredAddresses]);

  const [selectedBranch, setSelectedBranch] = useState(() => {
    const savedBranch = sessionStorage.getItem("SelectedBranch");
    return savedBranch ? JSON.parse(savedBranch) : "ALL";
  });

  const isClientUser = client !== null;
  const isConsultantUser = consultant !== null;

  let orgImg;
  let orgName;

  if (!isClientUser && !isConsultantUser) {
    orgImg = sessionStorage.getItem("OrgLogo");
    orgName = JSON.parse(sessionStorage.getItem("OrgDetails2"))?.name;
  }

  const [name, setName] = useState(orgName);
  const [img, setImg] = useState(orgImg);
  const [isChangePasswordModal, setIsChangePasswordModal] = useState(false);

  useEffect(() => {
    setImg(orgImg === "null" ? orgLogo : orgImg);
    setName(orgName);
  }, [orgImg, orgName]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      sessionStorage.clear();
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function logoutHandler() {
    sessionStorage.clear();
    navigate(RoutingPaths.LOGIN);
  }
  function toggleChangePasswordModal() {
    setIsChangePasswordModal(!isChangePasswordModal);
  }

  async function handleBranchChange(e) {
    const branchId = e.target.value;
    setSelectedBranch(branchId);

    if (branchId === "ALL") {
      sessionStorage.setItem("SelectedBranch", JSON.stringify("ALL"));
    } else {
      const selectedAddress = props.address?.find(
        (addr) =>
          addr.id?.toString() === branchId ||
          addr.addressId?.toString() === branchId,
      );

      if (selectedAddress) {
        const valueToStore = selectedAddress.id ?? selectedAddress.addressId;

        if (isConsultantUser) {
          const consultantDetails = await getConsultant();
          const reqBody = {
            ...consultantDetails,
            selectedBranchId: valueToStore,
          };

          const response = await updateConsultant(
            reqBody,
            consultantDetails.id,
          );

          if (response) {
            sessionStorage.setItem(
              "SelectedBranch",
              JSON.stringify(valueToStore),
            );
          }
        } else {
          const orgUserDetails = await getLoggedInUserDetails();

          let details = orgUserDetails.data?.data;

          const reqBody = {
            ...details,
            isAppointmentDetailsAccessAllowed:
              details?.userRole === "ROLE_ADMIN" &&
              details.isAppointmentDetailsAccessAllowed === false
                ? true
                : details.isAppointmentDetailsAccessAllowed,
            isPaymentAccessAllowed:
              details?.userRole === "ROLE_ADMIN" &&
              details.isPaymentAccessAllowed === false
                ? true
                : details.isPaymentAccessAllowed,
            isReportAccessAllowed:
              details?.userRole === "ROLE_ADMIN" &&
              details.isReportAccessAllowed === false
                ? true
                : details.isReportAccessAllowed,
            selectedBranchId: valueToStore,
          };

          const response1 = await updateAdminUserDetails(
            details.id,
            reqBody,
            true,
          );
          if (response1) {
            sessionStorage.setItem(
              "SelectedBranch",
              JSON.stringify(valueToStore),
            );
          }
        }
      }
    }

    window.dispatchEvent(new Event("branchChanged"));
  }

  return (
    <header className={`appBarX ${props.className}`}>
      <div className="appBar-left px-2">
        <i
          className="bi bi-list fs-5 menu-icon"
          onClick={props.toggleSidebar}
        />
        <img src={logo} alt="Logo" className="main-logo" />

        {!isClientUser && !isConsultantUser && (
          <div className="org-section">
            <span className="divider"></span>

            <div className="d-flex align-items-center gap-1">
              <div className="logoContainer">
                <img className="logo" src={img} alt="" />
              </div>
              <div className="nameContainer">
                <label className="textWrapper text-capitalize org-name">
                  {name}
                </label>
              </div>
            </div>
          </div>
        )}
      </div>

      <div
        className={`right-section d-flex align-items-center gap-2 ${
          !isClientUser && props.address?.length > 1
            ? "has-branch"
            : "no-branch"
        }`}
      >
        {!shouldHideBranch && !isClientUser && props.address?.length > 1 && (
          <div className="branch-container">
            <label htmlFor="selectConsultant">Select Branch</label>
            <select
              className="form-select branch-select"
              value={selectedBranch}
              onChange={handleBranchChange}
            >
              {allowedBranches?.length === 0 && (
                <option value="ALL">All</option>
              )}

              {filteredAddresses.map((addr) => {
                const optionValue = addr.id ?? addr.addressId;
                return (
                  <option key={optionValue} value={optionValue}>
                    {addr.addressLine1}
                  </option>
                );
              })}
            </select>
          </div>
        )}

        <div className="dropdown">
          <div className="profile dropdown-toggle" data-bs-toggle="dropdown">
            <i className="bi bi-person"></i>

            <span className="profileButtonName text-capitalize">
              {isConsultantUser
                ? `${consultant.firstName}`
                : isClientUser
                  ? `${client.firstName}`
                  : `${props?.profileData.firstName}`}
            </span>
          </div>

          <ul className="dropdown-menu dropdown-menu-end">
            {!isClientUser && (
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => navigate(RoutingPaths.ACCOUNT_SETTINGS)}
                >
                  <i className="bi bi-gear me-2"></i>Account Settings
                </button>
              </li>
            )}
            <li>
              <button
                className="dropdown-item"
                onClick={toggleChangePasswordModal}
              >
                <i className="bi bi-pencil-square me-2"></i>Change Password
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={logoutHandler}>
                <i className="bi bi-box-arrow-right me-2"></i>Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
      <ChangePasswordModal
        show={isChangePasswordModal}
        onHide={toggleChangePasswordModal}
      />
    </header>
  );
}

export default AppBar;
